import { registerRoute } from '../../app/registry';
import WorkReports from './WorkReports';

const ALL_ROLES = ['Requester', 'Designer', 'Accounts', 'Admin', 'SystemAdmin'];

registerRoute({
  path: '/reports',
  element: <WorkReports />,
  nav: { label: 'Reports', section: 'Reports', order: 10, icon: '📊', roles: ALL_ROLES },
  roles: ALL_ROLES,
});
